/**
 * 搭載文書検索APIサービス
 *
 * POST /insurance-documents/search エンドポイントへのアクセスを提供する。
 * BaseApiService を経由してJWT認証付きでリクエストを送信する。
 */
import ApiService from '../base/BaseApiService';

/**
 * 搭載文書を条件で検索する
 *
 * @param {Object} requestBody - 検索リクエストボディ
 * @param {number} requestBody.insurance_type_id - 生損保区分（1=生保, 2=損保）
 * @param {number} [requestBody.document_type_id] - 文書種別ID（省略時は全件）
 * @param {number[]} [requestBody.insurance_company_ids] - 保険会社IDリスト（省略時は全件）
 * @param {string[]} [requestBody.categories] - 保険商品種類リスト（省略時は全件）
 * @param {string} [requestBody.date_from] - 適用開始日時の下限（YYYY-MM-DDTHH:MM:SS）
 * @param {string} [requestBody.date_to] - 適用開始日時の上限（YYYY-MM-DDTHH:MM:SS）
 * @param {string} [requestBody.document_name_keyword] - 文書名キーワード（最大100文字）
 * @param {number} [requestBody.page] - ページ番号（デフォルト: 1）
 * @param {number} [requestBody.per_page] - 1ページあたりの件数（デフォルト: 50）
 * @returns {Promise<Object>} レスポンス（items, total, page, per_page, total_pages）
 * @throws {Error} APIエラー時
 */
export const searchDocumentCatalog = async (requestBody) => {
  try {
    return await ApiService.post('/insurance-documents/search', requestBody);
  } catch (error) {
    console.error('Error searching document catalog:', error.message);
    throw error;
  }
};
